import produce from "immer";
import IAreaStatementReducer from "models/IAreaStatementReducer";
import { actionTypes } from "./actions";
import { areaStatementSorting as defaultSorting } from "constants/sorting";

const initialState: IAreaStatementReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  areaStatementLines: [],
  statementLine: null,
  meta: {
    defaultSorting,
  },
  currentItem: null,
  error: null,
  typeOptions: [],
  statusOptions: [],
};

const transformPayload = (payload: any[]): any[] => {
  if (payload.length < 1) {
    return payload;
  }
  return payload.map((areaStatement) => {
    const agreement =
      areaStatement.LicenceContractLine.LicenceContract.ModelAgreement;
    let groupingType = "";
    switch (agreement) {
      case "BOL-ZANT":
        groupingType = "ZANTEDESCHIA";
        break;
      case "BOL-LELIE":
        groupingType = "LELIE";
        break;
      default:
        groupingType = "VOORJAARSGEWASSEN";
        break;
    }

    return { ...areaStatement, groupingType };
  });
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, (draftState) => {
    switch (action.type) {
      case actionTypes.GET_AREA_STATEMENT_SUCCESS:
        const newPayload = transformPayload(action.payload);
        draftState.items = newPayload;
        draftState.isLoading = false;
        draftState.isLoaded = true;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_AREA_STATEMENT_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.OPEN_AREA_STATEMENT_PAGE_SUCCESS:
        draftState.statementLine = action.payload;
        break;
    }
  });
